import { AbstractControl, AsyncValidatorFn, ValidationErrors, ValidatorFn } from "@angular/forms";
import { EmpleadoCrud } from "../../models/empleado";
import { EmpresasModel } from "src/app/pages/configuracion/maestros/empresas/models/empresas-model";
import { FiltroEmpleado } from "src/app/shared/models/filtros";
import { Observable, of } from "rxjs";
import { DatosEmpleadosService } from "./datos-empleados.service";
import { catchError, map } from "rxjs/operators";

export function validacionCodigo(empleados: EmpleadoCrud[], empleado: EmpleadoCrud): ValidatorFn {
  return (control:AbstractControl) : ValidationErrors | null => {
    const value = control.value;
    if (value == '' || value == null) {
        return {codigoVacio: true};
    }else{
      let codigoExiste = empleados.findIndex(x => x.codigo.toUpperCase() == control.value.toUpperCase())

      if(codigoExiste > -1){
        let mismoNif = empleados.findIndex(x=> x.nif == empleado.nif)
        if(mismoNif > -1 && codigoExiste == mismoNif){
          return null
        }else{
          return {codigoExiste: true}
        }
      }else{
        return null
      }
    }
  }
}

export function formEmpleadoValidatorsOld(empleados: EmpleadoCrud[], empleado: EmpleadoCrud): ValidatorFn {
  return (form:AbstractControl) : ValidationErrors | null => {
      const nif = form.get('nif').value;
      const empresa = form.get('empresa').value;
      const _codigoEmpresa = empresa?.split('-')[0];
      const codigo = form.get('codigo').value;

      let nifExiste = empleados.findIndex(x => x.nif.toUpperCase() == nif?.toUpperCase());

      if(codigo==empleado.codigo && codigo!==''){
        if(nifExiste>-1 && nif!==empleado.nif){
          if(_codigoEmpresa==empleados[nifExiste].codigoEmpresa) return {empleadoExiste: true};
          else return null
        }else return null
      }else if(codigo == '' && nifExiste>-1){
        if(_codigoEmpresa==empleados[nifExiste].codigoEmpresa) return {empleadoExiste: true};
        else return null
      }else return null

    }
}

export function formEmpleadoValidators(datosEmpleadosService: DatosEmpleadosService, empleado: EmpleadoCrud): AsyncValidatorFn {
  return (form: AbstractControl): Observable<ValidationErrors | null> => {
    const nif = form.get('nif')?.value;
    const empresa = form.get('empresa')?.value;
    const _codigoEmpresa = empresa?.split('-')[0];
    const codigo = form.get('codigo')?.value;

    if (!nif || !_codigoEmpresa) {
      return of(null);
    }

    const filtroNif: FiltroEmpleado = {
      text: 'Nif',
      listaValores: [nif]
    };
    const filtroEmpresa: FiltroEmpleado = {
      text: 'Empresa',
      listaValores: [_codigoEmpresa]
    };

    return datosEmpleadosService.getEmpleados([filtroNif, filtroEmpresa], 1).pipe(
      map((empleados: EmpleadoCrud[]) => {
        if (!empleados?.length) {
          return null;
        }
        // Conflicto si hay algún empleado distinto al que se está editando
        const hayConflicto = empleados.some(e => e.codigo !== codigo);
        return hayConflicto ? { empleadoExiste: true } : null;
      }),
      catchError(() => of(null))
    );
  };
}

export function formEmpleadoValidatorsWorking(datosEmpleadosService: DatosEmpleadosService, empleado: EmpleadoCrud): ValidatorFn {
  return (form: AbstractControl): Observable<ValidationErrors | null> => {
    const nif = form.get('nif').value;
    const empresa = form.get('empresa').value;
    const _codigoEmpresa = empresa?.split('-')[0];
    const codigo = form.get('codigo').value;

    if (!nif || !_codigoEmpresa) {
      return of(null);
    }

    const filtroNif: FiltroEmpleado = {
      text: 'Nif',
      listaValores: [nif]
    };
    const filtroEmpresa: FiltroEmpleado = {
      text: 'Empresa',
      listaValores: [_codigoEmpresa]
    };

    return new Observable(observer => {
      datosEmpleadosService.getEmpleados([filtroNif, filtroEmpresa], 1).subscribe(
        next => {
          if (!next?.length) {
            observer.next(null);
          } else {
            const hayConflicto = next.some(e => e.codigo !== codigo);
            observer.next(hayConflicto ? { empleadoExiste: true } : null);
          }
          observer.complete();
        },
        () => {
          observer.next(null);
          observer.complete();
        }
      );
    });
  };
}

export function validacionCentroEmpleado(
  predicate: () => AbstractControl,
  empresasOrProvider: EmpresasModel[] | (() => EmpresasModel[])
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    const codigoEmpresaValue = predicate().get('empresa')?.value?.split('-')[0];
    const empresas = typeof empresasOrProvider === 'function' ? empresasOrProvider() : empresasOrProvider;
    if (codigoEmpresaValue) {
      const numeroCentros = empresas.find(x => x.codigoEmpresa == codigoEmpresaValue)?.centros?.length ?? 0;
      if (numeroCentros > 0 && (value == '' || value == null)) {
        return { centroNecesario: true };
      }
      return null;
    }
    return null;
  };
}

  // getEmpleados(filtrosEmpleados: FiltroEmpleado[], pageNumber:number, orden?: OrdenColumna){
  //   this.datosEmpleadosService.getEmpleados(filtrosEmpleados, pageNumber, orden).subscribe(
  //     next => {
  //       this.empleados = next;
  //     },
  //     error => {
  //       console.error();
  //     }
  //   )
  // }
